import React from 'react';
import refreshIcon from '../../assets/refresh.svg';

const RatingHeader = ({ onRefresh }) => {
    return (
        <div className="rating-top-header">
            <button className="refresh-button invisible" aria-hidden="true">
                <div className="corners"></div>
                <img src={refreshIcon} alt="" />
            </button>
            <div className="rating-title">
                РЕЙТИНГ ИГРОКОВ
                <div className="title-corner-bl"></div>
                <div className="title-corner-br"></div>
            </div>
            <button className="refresh-button" onClick={onRefresh}>
                <div className="corners"></div>
                <img src={refreshIcon} alt="Обновить" />
            </button>
        </div>
    );
};

export default RatingHeader; 